import React from "react";
import { Link, useLocation } from "react-router-dom";

const AdminNav: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-gray-800 text-white p-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-6">
          <Link to="/dashboard" className="text-gray-300 hover:text-white">
            ← ダッシュボードに戻る
          </Link>
          <div className="flex gap-4 ml-auto">
            <Link
              to="/admin"
              className={`px-4 py-2 rounded-md transition-colors ${
                isActive("/admin")
                  ? "bg-purple-600 text-white"
                  : "text-gray-300 hover:bg-gray-700"
              }`}
            >
              統計
            </Link>
            <Link
              to="/admin/users"
              className={`px-4 py-2 rounded-md transition-colors ${
                isActive("/admin/users")
                  ? "bg-purple-600 text-white"
                  : "text-gray-300 hover:bg-gray-700"
              }`}
            >
              ユーザー管理
            </Link>
            <Link
              to="/admin/contacts"
              className={`px-4 py-2 rounded-md transition-colors ${
                isActive("/admin/contacts")
                  ? "bg-purple-600 text-white"
                  : "text-gray-300 hover:bg-gray-700"
              }`}
            >
              お問い合わせ
            </Link>
            <Link
              to="/admin/company-templates"
              className={`px-4 py-2 rounded-md transition-colors ${
                isActive("/admin/company-templates")
                  ? "bg-purple-600 text-white"
                  : "text-gray-300 hover:bg-gray-700"
              }`}
            >
              企業テンプレート
            </Link>
            <Link
              to="/admin/audit-logs"
              className={`px-4 py-2 rounded-md transition-colors ${
                isActive("/admin/audit-logs")
                  ? "bg-purple-600 text-white"
                  : "text-gray-300 hover:bg-gray-700"
              }`}
            >
              監査ログ
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNav;
